var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"layout":"tabbed"}},[_c('page-header-new',{attrs:{"title":_vm.pageTitle,"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('page-tabs',{attrs:{"tabs":_vm.availableTabs}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52935a3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/settings/pages/ChannelSettingsPage.vue
// module id = null
// module chunks = 